import React, { FC } from 'react'

export const HomePage: FC = () => {
  return <div />
}
